<!-- <app-menu> -->
  <mat-accordion multi="true">
    <mat-expansion-panel *ngFor="let row of rows">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Row {{ row.rowNumber }} - Total Spots: {{ row.total_positions }},
          Filled: {{ row.filled_positions }}, Empty: {{ row.empty_positions }}, {{ row.most_common_organization }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="section-container">
        <mat-expansion-panel *ngFor="let area of row.areas" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Section {{ area.section }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="levels-grid">
            <div *ngFor="let position of area.positions" class="level-panel">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Position {{ position.positionId }}
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="positions-container">
                <div *ngFor="let package of position.packages" class="position"
                  (mouseover)="hoverStates[package.package_uuid] = true"
                  (mouseleave)="hoverStates[package.package_uuid] = false">

                  <span *ngIf="position.packages.length > 0; else emptySpot"
                    class="material-icons pallet-full">inventory_2</span>
                  <ng-template #emptySpot><span
                      class="material-icons pallet-empty">check_box_outline_blank</span></ng-template>

                  <div *ngIf="hoverStates[package.package_uuid] && package.package_uuid" class="position-details">
                    <!-- <p>Package UUID: {{ position.package_uuid }}</p>
                    <p>Contact UUID: {{ position.contact_uuid }}</p> -->
                    <p>Contact Organization: {{ package.contact_organization }}</p>
                    <p>Model: {{ package.model }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
<!-- </app-menu> -->